<template>
  <div
    :style="{
      backgroundColor:
        $utils.extractValue(backgroundColor, 'transparent', $route) == ''
          ? 'transparent'
          : $utils.extractValue(backgroundColor, 'transparent', $route)
    }"
    class="w-full p-0 overflow-hidden group">
    <div class="absolute right-2 top-2 cursor-pointer opacity-0 group-hover:opacity-100" @click="editComponent()">
      <Pencil class="w-5 h-5 text-common-grey" :class="[{ 'text-white': $store.state.ui.darkMode }]" />
    </div>
    <div
      class="text-xl text-medium"
      :class="[
        { 'dark:text-white': $utils.extractValue(backgroundColor, 'transparent', $route) == 'transparent' },
        { 'text-white': $utils.extractValue(backgroundColor, 'transparent', $route) == 'black' }
      ]">
      {{ $utils.extractValue(label, "N/A", $route) }}
    </div>

    <TextEditor
      :combined-values-listener="label + description + backgroundColor"
      :class="[{ 'text-red-500': $utils.extractValue(backgroundColor, 'transparent', $route) == 'black' }]"
      class="relative h-[calc(100%-46px)]"
      :preserve-text-color="$utils.extractValue(backgroundColor, 'transparent', $route) !== 'transparent'"
      :transparent-bg="true"
      :disabled="true"
      :no-border="true"
      :value="$utils.extractValue(description, 'N/A', $route)"
      :name="`description`"
      label="" />

    <div
      v-if="$route.name == 'CompanyProfile' || $route.name == 'ObjectProfile'"
      class="absolute z-50 text-xs cursor-pointer bottom-1 right-2 text-common-grey has-tooltip">
      <Info class="w-4 h-4 text-common-grey" />
      <span
        class="inline-flex items-center gap-2 px-2 py-1 -mt-10 text-xs font-medium rounded-md tooltip -ml-28 whitespace-nowrap bg-light-screen-background dark:bg-dark-screen-background dark:text-dark-body-text">
        {{ $t("showing on") }} {{ typeof label == "object" ? $t("this page") : $t("all pages") }}</span>
    </div>
    <!-- <div class="mt-3 mbn-2" v-html="note.description" /> -->
  </div>
</template>

<script>
import TextEditor from "@/components/shared/TextEditor.vue"
import { Pencil, Info } from "lucide-vue-next"
import { ALL_EMITTERS } from "@/store/constants/all_emitters"

export default {
  components: { TextEditor, Info, Pencil },
  inject: ["canUserEditLayout"],
  props: {
    label: null,
    description: null,
    pageReference: null,
    item: null,
    currentTemplate: null,
    backgroundColor: null
  },
  emits: [],
  data() {
    return {}
  },
  computed: {},
  watch: {},

  created() {},

  methods: {
    editComponent() {
      this.$emitter.emit(ALL_EMITTERS.ADD_NEW_COMPONENT, { page_reference: this.pageReference, current_template: this.currentTemplate })
      setTimeout(() => {
        this.$emitter.emit(ALL_EMITTERS.EDIT_INSTANCE, this.item)
      }, 400)
    }
  }
}
</script>
